// extracted by mini-css-extract-plugin
module.exports = {"pintxo-avatar":"Avatar_pintxo-avatar__H6k3x","pintxo-avatar__shape":"Avatar_pintxo-avatar__shape__nGVaI","pintxo-avatar__shape__text":"Avatar_pintxo-avatar__shape__text__JthMm"};